import t, { Component as e } from "react";
import { paramCase as r } from "../../../../node_modules/param-case/dist.es2015/index.js";
function n(t, e) {
  (null == e || e > t.length) && (e = t.length);
  for (var r = 0, n = Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function o(t) {
  if (void 0 === t) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function c(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
  }
}
function i(t, e, r) {
  return e in t ? Object.defineProperty(t, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = r, t;
}
function u(t) {
  return (u = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  })(t);
}
function a(t, e) {
  return (a = Object.setPrototypeOf || function (t, e) {
    return t.__proto__ = e, t;
  })(t, e);
}
var l = function (e) {
  !function (t, e) {
    if ("function" != typeof e && null !== e) throw TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: t,
        writable: !0,
        configurable: !0
      }
    }), e && a(t, e);
  }(y, e);
  var l,
    f,
    s,
    p = (l = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }(), function () {
      var t,
        e,
        r = u(y);
      if (l) {
        var n = u(this).constructor;
        e = Reflect.construct(r, arguments, n);
      } else e = r.apply(this, arguments);
      return (t = e) && ("object" == (t && "undefined" != typeof Symbol && t.constructor === Symbol ? "symbol" : typeof t) || "function" == typeof t) ? t : o(this);
    });
  function y() {
    var t;
    return !function (t, e) {
      if (!(t instanceof e)) throw TypeError("Cannot call a class as a function");
    }(this, y), t = p.apply(this, arguments), i(o(t), "flatten", function (e) {
      var r = {},
        o = !0,
        c = !1,
        u = void 0;
      try {
        for (var a, l = Object.entries(e)[Symbol.iterator](); !(o = (a = l.next()).done); o = !0) {
          var f,
            s = (f = a.value, function (t) {
              if (Array.isArray(t)) return t;
            }(f) || function (t, e) {
              var r,
                n,
                o = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
              if (null != o) {
                var c = [],
                  i = !0,
                  u = !1;
                try {
                  for (o = o.call(t); !(i = (r = o.next()).done) && (c.push(r.value), !e || c.length !== e); i = !0);
                } catch (t) {
                  u = !0, n = t;
                } finally {
                  try {
                    i || null == o.return || o.return();
                  } finally {
                    if (u) throw n;
                  }
                }
                return c;
              }
            }(f, 2) || function (t, e) {
              if (t) {
                if ("string" == typeof t) return n(t, e);
                var r = Object.prototype.toString.call(t).slice(8, -1);
                if ("Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r) return Array.from(r);
                if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return n(t, e);
              }
            }(f, 2) || function () {
              throw TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }()),
            p = s[0],
            y = s[1];
          "object" == typeof y ? r = function (t) {
            for (var e = 1; e < arguments.length; e++) {
              var r = null != arguments[e] ? arguments[e] : {},
                n = Object.keys(r);
              "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function (t) {
                return Object.getOwnPropertyDescriptor(r, t).enumerable;
              }))), n.forEach(function (e) {
                i(t, e, r[e]);
              });
            }
            return t;
          }({}, r, t.flatten(y)) : r[p] = y;
        }
      } catch (t) {
        c = !0, u = t;
      } finally {
        try {
          o || null == l.return || l.return();
        } finally {
          if (c) throw u;
        }
      }
      return r;
    }), t;
  }
  return f = [{
    key: "render",
    value: function value() {
      var e,
        n,
        o = this.props,
        c = o.theme,
        i = o.prefersColorMediaQuery,
        u = this.props.scope ? this.props.scope + "-" : "",
        a = this.flatten(c),
        l = Object.keys(a).filter(function (t) {
          return !/^(root|scope)/.test(t);
        }).map(function (t) {
          return "--".concat(r(u + t), "-color: ").concat(a[t], ";");
        }),
        f = null === (e = c.colorVariables) || void 0 === e ? void 0 : e.primaryText,
        s = null === (n = c.colorVariables) || void 0 === n ? void 0 : n.primaryBackground;
      return f && l.push("color: ".concat(f, ";")), s && l.push("background-color: ".concat(s, ";")), t.createElement("style", null, i && "@media (prefers-color-scheme: ".concat(i, "){"), this.props.root, " ", "{", l.join("\n"), "}", i && "}");
    }
  }], c(y.prototype, f), s && c(y, s), y;
}(e);
i(l, "displayName", "ThemeProvider"), i(l, "defaultProps", {
  root: "body",
  scope: ""
});
export { l as ThemeProvider };